import { useQuery } from "react-query";
import i18next from "i18next";
import Select from "react-select";

import { getcityBycountryId } from "../../../../../MyApi/sb/cites";
import { getCurrency } from "../../../../../MyApi/sb/currency";
import { getCountries } from "../../../../../MyApi/sb/countries";
import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getShifts } from "../../../../../MyApi/sb/shifts";

import { timeZones } from "./timeZone";
import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";
import Map from "../../../../../pages/map";

import classes from "./addBranch.module.css";

const AddBranch = ({
  setLocations,
  setStates,
  states,
  setCountryId,
  active,
  countryId,
  setActive,
  selectedCompany,
  setCityId,
  setCompanyId,
  setTimeZone,
  setAdress,
  setPhone,
  phone,
  address,
  setCurrencyId,
  setBranchName,
  setMainStatus,
  setShiftId,
  shiftId,
  mainStatus,
  branchName,
}) => {
  const cityQuery = useQuery(
    ["getcityByCountryId", countryId],
    () => getcityBycountryId(countryId),
    {
      enabled: !!countryId,
    }
  );
  const countryQuery = useQuery("getCountries", getCountries);
  const currencyQuery = useQuery("getCurrency", getCurrency);
  const companyQuery = useQuery("getcompanies", getCompanies);
  const shiftsQuery = useQuery("getShifts", getShifts);
  const { t } = i18next;
  const cites = cityQuery.data?.data || [];
  const countries = countryQuery.data?.data || [];
  const currencies = currencyQuery.data?.data || [];
  const companies = companyQuery.data?.data || [];
  const shifts = shiftsQuery.data?.data || [];

  const DollarSign = icons.Dollar;
  const Company = icons.company;
  const Country = icons.Earth;

  const Branch = icons.branch;
  const Timezone = icons.timeZone;
  const Phone = icons.phone;
  const Address = icons.address;

  const handleNameChange = (e) => {
    setBranchName(e.target.value);
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };
  const handleAddressChange = (e) => {
    setAdress(e.target.value);
  };
  const handleMainChange = (e) => {
    const isChecked = e.target.checked;
    setMainStatus(isChecked ? 1 : 0);
  };
  const handleStatesChange = (e) => {
    setStates(e.target.value);
  };

  const handleCurrencyIdChange = (SelectedCurrency) => {
    const currencyId = SelectedCurrency ? SelectedCurrency.id : 0;
    setCurrencyId(currencyId);
  };

  const handleCountryIdChange = (selectedCountry) => {
    const countryId = selectedCountry ? selectedCountry.id : 0;
    setCountryId(countryId);
  };
  const handelCityIdChange = (selectedcity) => {
    const cityId = selectedcity ? selectedcity.id : 0;
    setCityId(cityId);
  };
  const handleCompanyIdChange = (selectedCompany) => {
    const companyId = selectedCompany ? selectedCompany.id : 0;
    setCompanyId(companyId);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };
  const handleCheckdBoxIds = (e) => {
    const isChecked = e.target.checked;
    const checkedIds = e.target.id;
    if (isChecked) {
      setShiftId((prevCheckedIds) => {
        return [...prevCheckedIds, +checkedIds];
      });
    } else {
      return setShiftId(shiftId.filter((id) => +checkedIds !== id));
    }
  };
  const handleTimeZone = (e) => {
    const {value}=e.target
    setTimeZone(value);
  };

  if (
    countryQuery.isLoading ||
    currencyQuery.isLoading ||
    (companyQuery.isLoading && shiftsQuery.isLoading)
  ) {
    return <LoadingSpinner />;
  }

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الفرع</label>
          <div className={classes.iconInput}>
            <Branch />
          </div>
          <input
            type="text"
            value={branchName}
            placeholder="ادخل اسم الفرع"
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> رقم الهاتف </label>
          <div className={classes.iconInput}>
            <Phone />
          </div>
          <input
            type="text"
            value={phone}
            placeholder=" رقم الهاتف "
            onChange={handlePhoneChange}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> العنوان</label>
          <div className={classes.iconInput}>
            <Address />
          </div>
          <input
            type="text"
            value={address}
            placeholder="ادخل الدول "
            onChange={handleAddressChange}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> الدول</label>
          <div className={classes.iconInput}>
            <Address />
          </div>
          <input
            type="text"
            value={states}
            placeholder="ادخل الدول "
            onChange={handleStatesChange}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label htmlFor="company"> اختار الشركة</label>
          {!companyQuery.data ? (
            <div> no data available</div>
          ) : (
            <Select
              type="text"
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              isClearable={true}
              options={companies}
              placeholder="اختار الشركة"
              onChange={handleCompanyIdChange}
            />
          )}
        </div>

        <div className={classes.formCol}>
          <label htmlFor="company"> اختار الدولة</label>
          {!countryQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              isClearable={true}
              options={countries}
              placeholder="اختار الدولة "
              onChange={handleCountryIdChange}
            />
          )}
        </div>

        <div className={classes.formCol}>
          <label htmlFor="currency"> اختار العملة</label>

          {!currencyQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              isClearable={true}
              options={currencies}
              placeholder="اختار العملة"
              onChange={handleCurrencyIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="city"> اختار المدينة</label>
          {!cityQuery.data ? (
            <div>يجب اختيار دولة </div>
          ) : (
            <Select
              type="text"
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              isClearable={true}
              options={cites}
              placeholder="اختار المدينة "
              onChange={handelCityIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="currency"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {active === 1 ? " نشط" : "غير نشط"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>

        <div className={classes.formCol}>
          <label
            htmlFor="currency"
            className={
              mainStatus ? `${classes.active}` : `${classes.disActive}`
            }>
            {" "}
            {mainStatus === 1 ? " أساسي" : "غير أساسي"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleMainChange}
              checked={mainStatus}
            />
            <span class="slider round"></span>
          </label>
        </div>

        <div className={classes.formCol}>
          <label htmlFor="currency">اختار منطقة التوقيت</label>
          <div className={classes.iconInput}>
            <Timezone />
          </div>
          <select
            type="text"
            onChange={handleTimeZone}
            className={classes.inputCustom}>
            <option value="">اختار منطقة التوقيت</option>
            {Object.entries(timeZones).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
          </select>
        </div>

        <div className={classes.formCol}>
          <label htmlFor="worksShift"> اختار نوبة العمل</label>

          {!shiftsQuery.data ? (
            <div>no data available</div>
          ) : (
            shifts.map((shift) => (
              <div key={shift.id} className={classes.checkBox}>
                <input
                  type="checkbox"
                  id={shift.id}
                  onChange={handleCheckdBoxIds}
                />
                <label htmlFor={shift.id}>{shift.name}</label>
              </div>
            ))
          )}
        </div>
      </div>
      <Map setLocations={setLocations} />
    </div>
  );
};

export default AddBranch;
